import Vue from "vue";
import AppModal from "./modal";

Vue.component(AppModal.name, AppModal);



// WEBPACK FOOTER //
// ./src/components/resuables/index.js